import './scss/app.scss';
import './utils/dateUtils';
import { BrowserRouter } from 'react-router-dom';
import RootRoutes from './routes/RootRoutes';
import ApplyInterceptor from './ApplyInterceptor';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect } from 'react';
import { ProductFruits } from 'react-product-fruits';
import { useAppDispatch, useAppSelector } from './app/hooks';
import { setIp } from './store/user/actions';
import { Mixpanel, MIXPANEL_PLATFORM } from './utils/mixpanel';
import Bowser from 'bowser';
import * as Sentry from '@sentry/react';
import QueryParamsWatcher from './QueryParamsWatcher';
import TooltipV2 from './common/_custom/TooltipV2/TooltipV2';
import { useIsMobile } from './common/_custom/Hooks/useIsMobile';
let is_prod = process.env.REACT_APP_ENVIRONMENT === 'production';
let is_staging = process.env.REACT_APP_ENVIRONMENT === 'staging';
let product_fruit_code = process.env.REACT_APP_PRODUCT_FRUIT_CODE;
function App() {
    const dispatch = useAppDispatch();
    const userId = useAppSelector((state) => state.user.userData.userId);
    const userName = useAppSelector((state) => state.user.userData.userName);
    const pnoName = useAppSelector((state) => state.user.userData.pnoName);
    const userType = useAppSelector((state) => state.user.userData.accountType);
    const pnoId = useAppSelector((state) => state.user.userData.investorOrgId);
    const primaryEmail = useAppSelector((state) => state.user.userData.primaryEmail);
    const investorPrimaryEmail = useAppSelector((state) => state.user.userData.investorPrimaryEmail);
    const isMobile = useIsMobile();
    useEffect(() => {
        fetchIpData();
    }, []);
    const fetchIpData = () => {
        const url = process.env.REACT_APP_API_URL || '';
        url &&
            fetch(url)
                .then((response) => {
                    return response.json();
                })
                .then((res) => {
                    const headers = JSON.parse(res?.headers || '{}');
                    headers?.['x-forwarded-for'] && dispatch(setIp(headers?.['x-forwarded-for']));
                    const browser = Bowser.getParser(window.navigator.userAgent);
                    const platform = browser.getPlatform();
                    Mixpanel.register({
                        ip: headers?.['x-forwarded-for'],
                        OperatingSystem: browser.getOSName(),
                        OperatingSystem_Version: browser.getOSVersion(),
                        Browser: browser.getBrowserName(),
                        Browser_Version: browser.getBrowserVersion(),
                        DeviceVendor: platform.vendor,
                        DeviceModel: platform.model,
                        Platform: isMobile ? MIXPANEL_PLATFORM.MOBILE_WEB : MIXPANEL_PLATFORM.DESKTOP,
                    });
                })
                .catch((err) => console.error('Problem fetching IP Address', err));
    };
    const userInfo = {
        username: userName || 'logged_out_user',
        email: primaryEmail || 'logged_out_user@aica.com',
        props: {
            userId: userId || 'logged_out_user',
            investorOrgId: pnoId || 'logged_out_user',
            investorPrimaryEmail: investorPrimaryEmail || 'logged_out_user@aica.com',
            pnoName: pnoName || 'logged_out_user',
            userType: userType || 'logged_out_user',
        },
    };
    return (
        <div className="App">
            <BrowserRouter>
                <QueryParamsWatcher />
                <ApplyInterceptor />
                <RootRoutes />
            </BrowserRouter>
            {!!product_fruit_code && !!userId && is_prod && (
                <ProductFruits workspaceCode={product_fruit_code} language="en" user={userInfo} />
            )}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <TooltipV2 />
        </div>
    );
}
export default Sentry.withProfiler(App);
